import React from "react";

interface FundingRateData {
  symbol?: string;
  funding_rate?: string | number;
  mark_price?: string | number;
  index_price?: string | number;
  premium_rate?: string | number;
  ema_funding_rate?: string | number;
  next_funding_time_unix?: number;
  funding_interval_seconds?: number;
  is_valid?: boolean;
  is_stale?: boolean;
  option_type?: string;
  strike_price?: string | number;
}

interface FundingRateDetailsProps {
  data: FundingRateData;
}

export const FundingRateDetails: React.FC<FundingRateDetailsProps> = ({
  data,
}) => {
  return (
    <div className="funding-rate-details">
      <strong className="funding-rate-title">Funding Rate Details:</strong>
      <div className="funding-rate-grid">
        <div>
          <strong>Symbol:</strong> {data.symbol ?? "N/A"}
        </div>
        <div>
          <strong>Funding Rate:</strong>{" "}
          {data.funding_rate
            ? parseFloat(String(data.funding_rate)).toFixed(6)
            : "N/A"}
        </div>
        <div>
          <strong>Mark Price:</strong> {data.mark_price ?? "N/A"}
        </div>
        <div>
          <strong>Index Price:</strong> {data.index_price ?? "N/A"}
        </div>
        <div>
          <strong>Premium Rate:</strong> {data.premium_rate ?? "N/A"}
        </div>
        <div>
          <strong>EMA Funding Rate:</strong> {data.ema_funding_rate ?? "N/A"}
        </div>
        <div>
          <strong>Next Funding Time:</strong>{" "}
          {data.next_funding_time_unix
            ? new Date(data.next_funding_time_unix * 1000).toLocaleString()
            : "N/A"}
        </div>
        <div>
          <strong>Funding Interval:</strong>{" "}
          {data.funding_interval_seconds
            ? `${data.funding_interval_seconds}s`
            : "N/A"}
        </div>
        <div>
          <strong>Valid:</strong>{" "}
          {data.is_valid !== undefined
            ? data.is_valid
              ? "Yes"
              : "No"
            : "N/A"}
        </div>
        <div>
          <strong>Stale:</strong>{" "}
          <span
            className={`funding-rate-stale ${data.is_stale ? "" : "valid"}`}
          >
            {data.is_stale !== undefined
              ? data.is_stale
                ? "Yes"
                : "No"
              : "N/A"}
          </span>
        </div>
        {data.option_type && (
          <>
            <div>
              <strong>Option Type:</strong> {data.option_type}
            </div>
            <div>
              <strong>Strike Price:</strong> {data.strike_price ?? "N/A"}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

